export default __webpack_public_path__ + "static/media/contact-card.637c3eb2.svg";